import React from 'react';
import ReactDOM from 'react-dom/client';
import BearingSpeedRatings from './BearingSpeedRatings';

const $root: HTMLElement | null = document.getElementById(
	'timken-tool-bearing-speed-ratings',
);
if ( $root ) {
	ReactDOM.createRoot( $root ).render(
		<React.StrictMode>
			<BearingSpeedRatings />
		</React.StrictMode>
	);
}
